export default __webpack_public_path__ + "static/media/042-stairs.3f12785a.svg";